<template>
  <div>
    <b-modal
      :id="`modal-action-${action}`"
      :ref="`modal-action-${action}`"
      :title="`${title} documento`"
      :ok-title="title"
      cancel-title="Cancelar"
      no-close-on-backdrop
      @ok="commitAction"
      @cancel="cancelProcess"
      size="lg"
      centered
    >
      <div class="-mt-2">
        <form
          data-vv-scope="sign-document"
          class="mt-4"
          v-on:submit.prevent autocomplete="off"
        >
          <div class="row">
            <div class="col-3">
              <div class="col-12">
                <SignaturesContainer
                  :signatures="signatures"
                  v-model="signatureSelected"
                  placeholder="Buscar Firma"
                />
              </div>
            </div>
            <div
              class="col-9"
              v-if="selectedFile
                && fileOnFlow.detalle.documentosBase
                && fileOnFlow.detalle.documentosBase.length"
            >
              <PdfViewport
                :default-page="1"
                :s3url="selectedFile.url"
                :name="fileOnFlow.detalle.documentosBase[0].objetoNombre"
                :signatures="Object.values(step.signaturesDropped)"
                @loaded="$emit('loaded')"
                @page-click="onSignatureDropped"
                :closable-sign="true"
                @signature-delete="onSignatureDelete"
                @signature-drag-end="onSignatureDragEnd"
                :signature-width="signatureWidth"
                :signature-height="signatureHeight"
                :signature-type="signatureType"
              />
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  BModal,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import SignaturesContainer from '@/febos/chile/approvals/wizardFlow/components/SignaturesContainer';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import { SIGNATURE_TYPES } from '@/febos/global/pdf/config';
import ApprovalProcessStates from "@/febos/chile/approvals/mixins/ApprovalProcessStates";

const SIGNATURE_WIDTH = 150;
const SIGNATURE_HEIGHT = 50;
export default {
  components: {
    SignaturesContainer,
    PdfViewport,
    BModal
  },
  data() {
    return {
      flowStates: ApprovalProcessStates,
      error: {
        message: ''
      },
      selectedFile: undefined,
      isDroppingSignature: false,
      signatureSelected: undefined,
      signatureWidth: SIGNATURE_WIDTH,
      signatureHeight: SIGNATURE_HEIGHT,
      signatureType: SIGNATURE_TYPES.DraggableSignature,
      step: {
        signaturesDropped: {},
        ...this.draft,
      },
      signType: '',
      numeration: '',
      confirmed: false,
      noAction: false,
      folio: '',
      actionType: ''
    };
  },
  watch: {
    signatureSelected(newValue, prevValue) {
      if (this.isDroppingSignature) {
        this.isDroppingSignature = false;
        return;
      }

      if (!newValue && prevValue) {
        const {
          [prevValue.id]: ignored,
          ...cleanSignaturesDropped
        } = this.step.signaturesDropped;
        this.step.signaturesDropped = cleanSignaturesDropped;
      }
    }
  },
  computed: {
    ...mapGetters('Management', [
      'allDocuments'
    ]),
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    ...mapGetters('Approvals', [
      'loadingNumeration',
      'fileOnFlow',
      'fileOnFlowAttachments',
      'approvalsTemplates',
      'stepTypes',
      'stepRoles',
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    signatures() {
      console.log('PASOS', this.fileOnFlow.detalle.pasos);
      const signatures = this.fileOnFlow.detalle.pasos
        .filter((step) => (
          // eslint-disable-next-line eqeqeq
          step.paso.aprobacionesTipoRolId == RolTypes.SIGNER
            && !this.step.signaturesDropped[step.paso.id]
        ))
        .filter((step) => step.aprobacionesPasoEstadoId == this.flowStates.PENDING)
        .filter((step) => (
          step.desatendido !== true
        ))
        .map(({
          paso,
          x,
          y,
          pagina
        }) => ({
          name: paso.responsable,
          id: paso.id,
          tipoValorResponsableId: paso.tipoValorResponsableId,
          stepType: paso.aprobacionesTipoPasoId,
          x,
          y,
          page: pagina
        }));
      return signatures;
    },
  },
  methods: {
    ...mapActions('Approvals', [
      'processFileFlow',
      'manageFileFlow',
      'setProcessDocument'
    ]),
    onSignatureDropped({ x, y }, page) {
      if (!this.signatureSelected) {
        return;
      }
      this.step.signaturesDropped = {
        ...this.step.signaturesDropped,
        [this.signatureSelected.id]: {
          ...this.signatureSelected,
          x,
          y,
          page
        }
      };
      this.isDroppingSignature = true;
      this.signatureSelected = undefined;
    },
    onSignatureDelete(signature) {
      this.$delete(this.step.signaturesDropped, signature.id);
    },
    onSignatureDragEnd({ x, y }, signature) {
      this.step.signaturesDropped = {
        ...this.step.signaturesDropped,
        [signature.id]: {
          ...signature,
          x,
          y
        }
      };
    },
    cancelProcess() {},
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async signDocument() {
      // check if all signatures are dropped

      if (this.signatures.length) {
        this.$bvToast.toast(
          'Debe colocar todas las firmas en el documento',
          {
            title: 'Error',
            variant: 'danger',
            solid: true
          }
        );
        return;
      }

      const body = {
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        estado: 'CONFIGURAR',
        meta: {
          posiciones: Object.values(this.step.signaturesDropped).map(({
            id,
            x,
            y,
            page
          }) => ({
            pasoId: id,
            x,
            y,
            pagina: page
          }))
        }
      };
      const request = {
        idEjecucion: this.$route.params.flowId,
        idAprobacion: this.$route.params.fileId,
        pasoId: this.stepId.id
      };
      const payload = {
        request,
        body
      };
      const response = await this.processFileFlow(payload);
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.$refs[`modal-action-${this.action}`].hide();
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocument();
    },
    selectFile(file) {
      this.selectedFile = undefined;
      this.fileType = undefined;
      if (file && file.url.toLowerCase().includes('pdf')) {
        this.fileType = 'pdf';
        this.selectedFile = file;
      }
      this.selectedFile = file;
    },
    loadDroppedSignatures() {
      this.step.signaturesDropped = {};
      this.signatures.forEach((signature) => {
        if (signature.x && signature.y && signature.page) {
          this.step.signaturesDropped = {
            ...this.step.signaturesDropped,
            [signature.id]: signature
          };
        }
      });
    }
  },
  mounted() {
    this.selectFile(this.fileOnFlowAttachments[0]);
    this.loadDroppedSignatures();
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    process: { type: Boolean, required: false },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
<style scoped>
.wrap-numeration {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.warning-confirmation {
  background-color: #ff9800;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
